export default "__VITE_ASSET__CK3uKsF7__"